import { CardActions, CardContent, Collapse, Typography, styled, Tab, Box, Tabs } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { IFutureExtended } from "../PairSpreadItem/PairSpreadItem";
import { calcAmounts, defAmounts } from "../../utils/calc";
import { ISecurityExtended } from "../../models/finam";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { CustomTabPanel } from "./GraphSpreads";

interface IAmounts {
    baseCount: number;
    baseLots: number;
    futCount: number;
    futLots: number;
    profit: number;
}

interface PairSpreadCalcProps {
    base: ISecurityExtended;
    futures: IFutureExtended[];
    initDepositAmount: number;
}

export const PairSpreadCalc2: React.FC<PairSpreadCalcProps> = ({ base, futures, initDepositAmount } ) => {
    const [actualFuture, setActualFuture] = useState(0);
    const [amounts, setAmounts] = useState<IAmounts>(defAmounts)
    const [deposit, setDeposit] = useState(initDepositAmount);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const updatedAmounts = calcAmounts(base, futures[actualFuture], deposit);
        setAmounts(prevAmounts => {
            if (prevAmounts.baseCount === updatedAmounts.baseCount &&
                prevAmounts.futCount === updatedAmounts.futCount) {
                return prevAmounts;
            }
            return updatedAmounts;
        });
    }, [base.price, actualFuture, deposit]);

    const handleDepositChange = (event: ChangeEvent<HTMLInputElement>) => {
        let inputValue = event.target.value;
        if (inputValue === '')
            inputValue = '0';

        if (/^\d+$/.test(inputValue) && inputValue.length < 10) {
            setDeposit(parseInt(inputValue));
        }
    };

    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
    }));

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const getCalc = () => {
        return (
            <CardContent className='cardContent'>
                <div className='container'>
                    {`Депозит`}
                    <div>
                    <input
                        onChange={handleDepositChange}
                        placeholder="Депозит на сделку"
                        type="text"
                        value={ deposit } />
                    <span className='price'>руб.</span>
                    </div>
                </div>
                
                { futures[actualFuture].num !== undefined ?
                    <Typography color="text.secondary" className={'cardContent'}>
                        <div className='container'>
                            { `Продать фьючерс`}
                            <div>
                                <div className='price'>{`${amounts.futLots} лот.`}</div>
                                <div className='smallPrice'>{`${amounts.futCount} шт.`}</div>
                            </div>
                        </div>
                        <div className='container'>
                            { `Купить базовый` }
                            <div>
                                <div className='price'>{`${amounts.baseLots} лот.`}</div>
                                <div className='smallPrice'>{`${amounts.baseCount} шт.`}</div>
                            </div>
                        </div>
                        <div className='container'>
                            { `Прибыль (спред)` }
                            <span className='price'>{amounts.profit.toFixed(2)} руб.</span>
                        </div>
                    </Typography>
                    :
                    <Typography variant="body2" color="text.secondary">
                        <div className='infoCaption'>
                            { `⚠️ Нет данных` }
                        </div>
                    </Typography>
                }
            </CardContent>
        );
    }

    const a11yProps = (index: number) => {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActualFuture(newValue);
    };
 
    return (
        <>
            <CardActions disableSpacing className='expandCont'>
                <span className='expandTitle'>{ 'Калькулятор' }</span>
                <ExpandMore
                    expand={ expanded }
                    onClick={ handleExpandClick }
                    aria-expanded={ expanded }
                    aria-label="Подробнее"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: -2 }}>
                        <Tabs value={ actualFuture } onChange={ handleChange } aria-label="basic tabs example">
                            <Tab label={ futures[0].shortName } {...a11yProps(0)} />
                            <Tab label={ futures[1].shortName } {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={ actualFuture } index={0}>
                        { getCalc() }
                    </CustomTabPanel>
                    <CustomTabPanel value={ actualFuture } index={1}>
                        { getCalc() }
                    </CustomTabPanel>
                </CardContent>
            </Collapse>
        </>
    );
}